/* eslint-disable no-alert */
import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Table, Label, Icon } from 'semantic-ui-react'
import firebase from 'firebase/app'
import Cookie from 'js-cookie'
import moment from 'moment'

import DriverPendingTimer from '../../../../components/orders/DriverPendingTimer'

import FindDriver from './ActionButtons/FindDriver'
import LiveTracking from './ActionButtons/LiveTracking'
import SwitchDriver from './ActionButtons/SwitchDriver'
import ReserveDriver from './ActionButtons/ReserveDriver'
import AssignedDriver from './ActionButtons/AssignedDriver'
import FraudDetectionToggle from './ActionButtons/FraudDetection'

class DriverCell extends PureComponent {
  state = {
    finding: false,
    loading: false,
  }

  setLoading = (field, value) => this.setState({ [field]: value })

  onToggleFraudDetection = async () => {
    try {
      const { order } = this.props

      this.setState({ loading: true })

      const nonDetect = order.allowed_muuver_fraud_detection

      const updates = {
        [`orders/${order.key}/allowed_muuver_fraud_detection`]: nonDetect ? null : true,
      }

      await firebase
        .database()
        .ref()
        .update(updates)

      this.setState({ loading: false })
    } catch (err) {
      this.setState({ loading: false })
      alert(err.message || err)
    }
  }

  renderFindDriverButton = () => {
    const { readyToPickUp, remainingRtp, order, showManualAssign, readOnly } = this.props
    const isOrdered = order.item_order_status === 'ordered'

    if (readyToPickUp && remainingRtp > 0) return null

    if (readyToPickUp && remainingRtp <= 0 && !isOrdered) return null

    return (
      <FindDriver
        key="find"
        order={order}
        setLoading={this.setLoading}
        showManualAssign={showManualAssign}
        readOnly={readOnly}
        {...this.state}
      />
    )
  }

  renderReserveDriver = () => {
    const { readyToPickUp, remainingRtp, order, drivers, showReserve, readOnly } = this.props
    const isOrdered = order.item_order_status === 'ordered'
    const driverUid = order.reserve_driver
    const driver = drivers[driverUid]

    if (readyToPickUp && remainingRtp > 0) {
      return null
    }

    if (readyToPickUp && remainingRtp <= 0 && !isOrdered) {
      return null
    }

    return (
      <ReserveDriver
        key="reserve"
        driver={driver}
        order={order}
        setLoading={this.setLoading}
        showReserve={showReserve}
        readOnly={readOnly}
        {...this.state}
      />
    )
  }

  renderPendingDriver = () => {
    const { drivers, order } = this.props
    const driverUid = order.driver_pending_order
    const driver = drivers[driverUid]

    if (driver) {
      const driverName = `${driver.family_name} ${driver.first_name}`

      return (
        <DriverPendingTimer
          key="pending"
          driverTel={driverUid}
          driverName={driverName}
          expiredAt={order.driver_pending_expired_at}
          hasDivider={order.switching_driver}
        />
      )
    }

    return null
  }

  renderAssignedDriver = () => {
    const { drivers, order, delivererInProgressOrders } = this.props
    const driverUid = order.deliverer
    const driver = drivers[driverUid]

    if (!driver) return null

    return <AssignedDriver order={order} driver={driver} delivererInProgressOrders={delivererInProgressOrders} key="assign" />
  }

  renderLiveTracking = () => {
    const { showLiveTracking, readOnly } = this.props

    const shouldSyncDriversCookie = Cookie.get('should_sync_drivers')
    const shouldSyncDrivers = shouldSyncDriversCookie === undefined ? true : (shouldSyncDriversCookie === 'true')

    return <LiveTracking onClick={showLiveTracking} key="livetracking" disabled={readOnly || !shouldSyncDrivers} />
  }

  renderFraudDetectButton = () => {
    const { order } = this.props
    const { loading } = this.state

    return (
      <FraudDetectionToggle
        key="fraud-toggle"
        loading={loading}
        disabled={false}
        onClick={this.onToggleFraudDetection}
        detectable={!order.allowed_muuver_fraud_detection}
      />
    )
  }

  renderSwitchDriver = () => {
    const { order, driversGroupByPackage, showSwitchDriver, readOnly, drivers, delivererInProgressOrders, todayOrders } = this.props
    const driverUid = order.deliverer
    const driverInfo = drivers[driverUid]

    return (
      <SwitchDriver
        key="switch"
        order={order}
        driver={driverInfo}
        readOnly={readOnly}
        todayOrders={todayOrders}
        showSwitchDriver={showSwitchDriver}
        driversGroupByPackage={driversGroupByPackage}
        delivererInProgressOrders={delivererInProgressOrders}
      />
    )
  }

  renderContactLess = () => {
    const { order } = this.props

    if (!order.is_contact_less) return null

    return (
      <React.Fragment>
        <Label color="red" style={{ marginTop: 5, width: 120 }}>
          <Icon name="user times" />
          Contactless
        </Label>
      </React.Fragment>
    )
  }

  renderPickUp = () => {
    return (
      <React.Fragment>
        <Label color="green" style={{ marginTop: 5, width: 120 }}>
          Pick-Up
        </Label>
      </React.Fragment>
    )
  }

  renderDeliveryTime = () => {
    const { order } = this.props

    const deliveredAt = order.updated_at
    const acceptedAt = order.deliverer_accepted_at

    const compareDuration = moment(deliveredAt).diff(acceptedAt)
    const spendMinutes = Math.round(moment.duration(compareDuration).as('minutes'))

    return (
      <Label color="black" style={{ width: 120, margin: 0, marginTop: 5 }}>
        TimeSpan: {spendMinutes} min
      </Label>
    )
  }

  render() {
    const actions = []
    const { readyToPickUp, remainingRtp, order } = this.props
    const isOrdered = order.item_order_status === 'ordered'
    const isPickUp = order.order_type === 'pick-up'
    const isHasDriver = order.deliverer && ['confirmed', 'outForDelivery', 'delivered', 'drivers_not_available'].includes(order.status)

    if (isPickUp) {
      actions.push(this.renderPickUp())
    } else {
      if (isHasDriver) {
        actions.push(this.renderAssignedDriver())

        if (order.status !== 'delivered') {
          actions.push(this.renderLiveTracking())
          actions.push(this.renderSwitchDriver())
        }

        if (order.switching_driver && order.driver_pending_order && order.driver_pending_expired_at) {
          actions.push(this.renderPendingDriver())
        }
      } else if (order.driver_pending_order && order.driver_pending_expired_at) {
        actions.push(this.renderPendingDriver())
      } else if (order.reserve_driver) {
        actions.push(this.renderReserveDriver())
      } else if (
        !order.deliverer &&
        ['confirmed', 'drivers_not_available'].includes(order.status) &&
        !order.driver_pending_order
      ) {
        actions.push(this.renderFindDriverButton())
        actions.push(this.renderReserveDriver())
      }

      if (readyToPickUp && remainingRtp && remainingRtp > 0 && ['drivers_not_available', 'confirmed'].includes(order.status)) {
        actions.push(
          <Label color="green" style={{ width: 120, margin: 0, marginTop: 5 }}>
            Ready in {remainingRtp} minutes
          </Label>
        )
      } else if (readyToPickUp && remainingRtp <= 0 && !isOrdered && ['drivers_not_available', 'confirmed'].includes(order.status)) {
        actions.push(
          <Label color="orange" style={{ width: 120, margin: 0, marginTop: 5 }}>
            Order yet?
          </Label>
        )
      }

      actions.push(this.renderFraudDetectButton())
    }

    return (
      <Table.Cell textAlign="center">
        {actions}
        {this.renderContactLess()}
        {order.status === 'delivered' && order.deliverer_accepted_at ? this.renderDeliveryTime() : null}
      </Table.Cell>
    )
  }
}

const mapState = ({ drivers, orders, delivererOrders }) => ({
  drivers: drivers.drivers,
  todayOrders: orders.todayOrders.all,
  deliveredOrders: delivererOrders.deliveredOrders
})

export default connect(mapState)(DriverCell)



// WEBPACK FOOTER //
// ./src/containers/orders/components/OrderListItem/DriverCell.js